export const ReasonTexts = {
  EconomyOFMoney: 'Para economizar dinheiro. Usar bicicleta é mais barato.',
  Ecology: 'Porque é mais ecológico. A bicicleta não polui o ambiente.',
  EconomyOfTime:
    'Para economizar tempo. Usar bicicleta como transporte é mais eficiente.',
  Health: 'Para melhorar a saúde física e emocional.',
  Delivery: 'Porque começou a trabalhar com entregas.',
  Other: 'Outro.',
};

export enum ReasonEnum {
  EconomyOFMoney = '0',
  Ecology = '1',
  EconomyOfTime = '2',
  Health = '3',
  Delivery = '4',
  Other = '5',
}
